// Schema.org JSON-LD injection, kept separate from runtime OG/Twitter mutation.
// Uses the existing data source for the site name, URL and image.

import { SITE_URL, SITE_IMAGE, SITE_NAME } from "./data";

const MARKER = "data-readdy-seo-jsonld";

function inject(data: object): void {
  document
    .querySelectorAll(`script[${MARKER}]`)
    .forEach((el) => el.remove());

  const script = document.createElement("script");
  script.type = "application/ld+json";
  script.setAttribute(MARKER, "true");
  script.textContent = JSON.stringify(data);
  document.head.appendChild(script);
}

export function applyHomeJsonLd(description: string): void {
  inject({
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebSite",
        name: SITE_NAME,
        url: `${SITE_URL}/`,
        description,
        inLanguage: ["en", "fr", "da", "de"],
      },
      {
        "@type": "Organization",
        name: SITE_NAME,
        url: `${SITE_URL}/`,
        logo: {
          "@type": "ImageObject",
          url: SITE_IMAGE,
        },
      },
    ],
  });
}

export function applyArticleJsonLd(
  seo: { title: string; description: string; path: string },
  lang: string,
): void {
  inject({
    "@context": "https://schema.org",
    "@type": "Article",
    headline: seo.title,
    description: seo.description,
    image: SITE_IMAGE,
    inLanguage: lang,
    mainEntityOfPage: `${SITE_URL}${seo.path}`,
    author: {
      "@type": "Organization",
      name: SITE_NAME,
    },
    publisher: {
      "@type": "Organization",
      name: SITE_NAME,
      logo: {
        "@type": "ImageObject",
        url: SITE_IMAGE,
      },
    },
    datePublished: "2026-08-25",
    dateModified: "2026-08-25",
  });
}